import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import {optionsToString} from "@app/utils/CommonUtils";
import {ResponseCode} from "@app/constants/Common";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {alertMessage} from "@app/constants/Messages";
import {ServiceStatuses} from "@pages/candidate/detail/CandidateDVTJCUV";

const DVTJCUVNewTimesFields = [
    // {key: 'service_status', label: 'Trạng thái SD DV', classNames: '', displayType: 'text', inputType: 'option', editable: true, searchable: true, options: ServiceStatusOptions},
    {key: 'first_active_date_time', label: 'Activate Time', classNames: '', displayType: 'text', inputType: 'date', editable: true, capitalize: true, searchable: true},
    {key: 'service_use_month', label: 'Thời hạn sử dụng DV (Số tháng)', classNames: '', displayType: 'text', inputType: 'number', editable: true, capitalize: true, searchable: false},
    // {key: 'expiry_date_time', label: 'Expired Time', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},
    {key: 'note', label: 'Note', classNames: '', displayType: 'text', inputType: 'text', editable: true, capitalize: true, searchable: false},
];

const CandidateDVTJCUVInputNewTimesModal = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [dvtjcuv, setDVTJCUV] = useState({
        first_active_date_time: new Date().toISOString().split('T')[0], // Default to today
        service_use_month: 6,
        note: '',
    });

    const {candidateId, isShow, onClose} = props

    const onCreateNewUseTimes = async () => {
        // Validate nếu first_active_date_time nhỏ hơn ngày hiện tại thì hiển thị popup confirm với nội dung
        // "Bạn đang nhập back date cho Activate Time. Bạn có chắc chắn không?"
        // Nút "Yes">> Lưu giá trị
        // Nút "No" close popup confirm
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const inputDate = new Date(dvtjcuv.first_active_date_time);
        inputDate.setHours(0, 0, 0, 0);
        if (inputDate < today && dvtjcuv.service_status
            && (dvtjcuv.service_status.value === ServiceStatuses.ACTIVE.id
                || dvtjcuv.service_status.value === ServiceStatuses.RE_ACTIVE.id)) {
            const confirmResult = window.confirm("Bạn đang nhập back date cho Activate Time. Bạn có chắc chắn không?");
            if (!confirmResult) {
                return;
            }
        }

        setIsLoading(true)
        const body = {...dvtjcuv}
        body.candidate_id = candidateId;
        const res = await CandidateService.requestUpdateCandidateDVTJCUV(body)
        setIsLoading(false)
        if (res.sts_code === ResponseCode.SUCCESS) {
            showSuccessMessageSaveData(res.sts_code)
            onClose(true)
        } else {
            alertMessage(res.sts_code, true, true)
        }
    };

    const onCloseModal = () => {
        onClose()
    }

    const onChangeInput = (values, column) => {
        dvtjcuv[column.key] = values
        setDVTJCUV({...dvtjcuv})
    }

    const columnDisabled = (column) => {
        return !column.editable || isLoading;
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onCloseModal()}
                   animation={false} style={{zIndex: 3001}}>
                <Modal.Header>
                    <Modal.Title>Nhập lần SDDV mới</Modal.Title>
                    <Button variant='secondary' onClick={() => onCloseModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className={'row'}>
                        {DVTJCUVNewTimesFields.map((column) => {
                            return <div className='col-sm-6' key={`CandidateDVTJCUVInputNewTimes_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={'w-100'}>{column.label}</label>
                                    <input type={column.inputType} className='form-control'
                                           disabled={columnDisabled(column)}
                                           value={dvtjcuv[column.key]}
                                           name={column.key}
                                           onChange={event => onChangeInput(event.target.value, column)}/>
                                </div>
                            </div>
                        })}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type='button'
                            className='btn btn-primary'
                            disabled={Number(dvtjcuv.service_use_month) <= 0}
                            onClick={() => onCreateNewUseTimes()}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CandidateDVTJCUVInputNewTimesModal;
